import React, { useState, useRef, useEffect } from "react";
import "./fixed_profile_css.css";
import Navbar from "../Navbar/Navbar";
import defaultProfilePicture from "../../image/profile.png";
import Footer from "../Footer/Footer";
import axios from "axios";
import Config from "../../utils/Config";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  const notifyError = (text) => toast.error(text);
  const notifySuccess = (text) => toast.success(text);

  const [contact, setContact] = useState({
    address: "",
    report_email: "",
    practice_name: "",
  });

  const [settings, setSettings] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: ""
  });

  const fileInput = useRef(null);
  const [photo, setPhoto] = useState();
  const [isPhotoChanged, setIsPhotoChanged] = useState(false);

  const [isContactChanged, setIsContactChanged] = useState(false);
  const [isUserChanged, setIsUserChanged] = useState(false);

  const [allowUserChange, setAllowUserChange] = useState(false);
  const [allowContactChange, setAllowContactChange] = useState(false);

  const fileSelectorHandler = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();

      reader.onload = (e) => {
        setPhoto(e.target.result);
        setIsPhotoChanged(true);
      };

      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    setLoading(true);
    // const element = document.getElementById('photoChange');
    // element.src = "../image/save.png"

    const formData = new FormData();
    formData.append("file", fileInput.current.files[0]);

    await axios
      .post(`${Config.API_URL}/settings/profile`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        notifySuccess("Profile picture is updated");
        // setPhoto(fileInput.current.files[0]);
      });
    setLoading(false);
    setIsPhotoChanged(false);
  };

  const handleSettingsChange = (e) => {

    const { name, value } = e.target;
    setIsUserChanged(true);
    setSettings((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setIsContactChanged(true);
    setContact((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsContactChanged(false);
    setAllowContactChange(false)
    await axios({
      method: "POST",
      url: `${Config.API_URL}/settings/contact`,
      data: contact,
      JSON: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        notifySuccess(response.data.message);
        setLoading(false);
      })
      .catch((error) => {
        notifyError(error.response.data.detail);
        setLoading(false);
      });
  };

  const allowUserChanging = (e) => {
    setAllowUserChange(true);
    setIsUserChanged(true);
  };

  const allowContactChanging = (e) => {
    setAllowContactChange(true);
    setIsContactChanged(true);
    console.log("changing");
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsUserChanged(false);
    setAllowUserChange(false)
    await axios({
      method: "POST",
      url: `${Config.API_URL}/settings/user`,
      data: settings,
      JSON: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        notifySuccess(response.data.message);
        setLoading(false);
      })
      .catch((error) => {
        notifyError(error.response.data.detail);
        setLoading(false);
      });
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${Config.API_URL}/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.profile != null) {
          // Base64 image (you should always start with "data:image/png;base64,")
          setPhoto("data:image/png;base64," + response.data.profile);
        } else {
          setPhoto(defaultProfilePicture);
        }
        setUser(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate("/login");
        } else {
          notifyError(error.response.data.detail);
        }
      }
    };

    fetchUser();
  }, [navigate, token]);

  return (
    <div className="profileBackground">
      <div className="profile">
        <Navbar />
        <div className="container-fluid">
          <Toaster position="top-center" reverseOrder={false} />

          <div className="row">
            <div className="profileHeader">
              <h1 className="profileTitle">Profile</h1>
              <div className="profileInfo">
                <div className="col-sm-4">
                  <div className="profilePhoto">
                    <img className="img-fluid" src={photo} alt="profile" />
                  </div>
                   {isPhotoChanged ? (
                      <button
                        className="saveButton"
                        onClick={handleFileUpload}
                      >
                        {loading ? <>Saving...</> : <> </>}
                      </button>
                    ) : (
                      <button
                        className="changeButton"
                        onClick={() => fileInput.current.click()}
                      ></button>
                  )}
                </div>
                <input
                  style={{ display: "none" }}
                  type="file"
                  onChange={fileSelectorHandler}
                  ref={fileInput}
                />
                <h1 className="greeting">
                  Hello Dr. {user.first_name} {user.last_name}
                </h1>
              </div>
            </div>
            <div className="col-sm-8">
              <div className="profileSettings">
                <div className="profileMain">
                  <div className="tableSearch_Billing">
                    <div className="headings">User Setting </div>
                    {/* <button className="changeButton" onClick={handleUserSubmit}>
                      {loading ? <>Saving...</> : <> </>} 
                    </button>*/}
                    {isUserChanged ? (
                      <button
                        className="saveButton"
                        onClick={handleUserSubmit}
                      >
                        {loading ? <> </> : <> </>}
                      </button>
                    ) : (
                      <button
                        className="changeButton"
                        onClick={()=>{allowUserChanging()}}
                      ></button>
                    )}
                  </div>

                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>First Name</label>
                      <input
                        className="RegisterFromData"
                        type="text"
                        name="first_name"
                        placeholder={user.first_name}
                        value={settings.first_name}
                        disabled={!allowUserChange}
                        onChange={handleSettingsChange}
                      />
                    </div>
                  </div>
                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>Last Name</label>
                      <input
                        className="RegisterFromData"
                        type="text"
                        name="last_name"
                        placeholder={user.last_name}
                        value={settings.last_name}
                        disabled={!allowUserChange}
                        onChange={handleSettingsChange}
                      />
                    </div>
                  </div>
                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>Phone Number</label>
                      <input
                        name="phone_number"
                        value={settings.phone_number}
                        onChange={handleSettingsChange}
                        className="RegisterFromData"
                        type="text"
                        disabled={!allowUserChange}
                        placeholder={user.phone_number}
                      />
                    </div>
                  </div>
                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>Email Address</label>
                      <input
                        name="email"
                        value={settings.email}
                        onChange={handleSettingsChange}
                        className="RegisterFromData"
                        type="text"
                        disabled={true}
                        placeholder={user.email}
                      />
                    </div>
                  </div>
                </div>
                <div className="profileMain">
                  <div className="tableSearch_Billing">
                    <div className="headings"> Contact Setting </div>
                    { /*<button className="changeButton" onClick={handleContactSubmit}>
                      {loading ? <>Saving...</> : <> </>}
                    </button> */}
                    {isContactChanged ? (
                      <button
                        className="saveButton"
                        onClick={handleContactSubmit}
                      >
                        {loading ? <> </> : <> </>}
                      </button>
                    ) : (
                      <button
                        className="changeButton"
                        onClick={()=>{allowContactChanging()}}
                      ></button>
                    )}
                  </div>
                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>Practice Name</label>
                      <input
                        name="practice_name"
                        value={contact.practice_name}
                        onChange={handleContactChange}
                        className="RegisterFromData2"
                        type="text"
                        disabled={!allowContactChange}
                        placeholder={user.practice_name}
                      />
                    </div>
                  </div>
                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>Report Receiving Email</label>
                      <input
                        name="report_email"
                        value={contact.report_email}
                        onChange={handleContactChange}
                        className="RegisterFromData2"
                        type="text"
                        disabled={!allowContactChange}
                        placeholder={user.report_email}
                      />
                    </div>
                  </div>
                  <div className="RegisterName">
                    <div className="profileFrom formRow2">
                      <label>Address</label>
                      <input
                        name="address"
                        value={contact.address}
                        onChange={handleContactChange}
                        className="RegisterFromData2"
                        type="text"
                        disabled={!allowContactChange}
                        placeholder={user.address}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
